import React, { Component } from 'react'

import Page from '../result/Page'
import News from '../result/News'
import Button from '../result/Button'
import People from '../result/People'
import Course from '../result/Course'
import Event from '../result/Event'

const ResultComponents = {
  news: News,
  courses: Course,
  people: People,
  events: Event,
  button: Button,
}

const GroupTitles = {
  externalSearchResults: 'External Sites',
  Featured: 'Top Results',
  program: 'Programs',
}

export default class ResultsList extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		console.log(this.props.groups);
		return (
			<ul className="results">
			  {this.props.groups.map((group) => {
			    return (
			      <div className="grouping" key={group.type}>
			        <div className={`${group.type}-entries`}>
			          {group.type !== 'button' && group.results.length > 0 && (<h1 className="result-group">{GroupTitles[group.type] || group.type}</h1>)}
			          <ul>
			            {group.results.length > 0 && group.results.map((result, index) => {
			              const ResultComponent = ResultComponents[result.type] || Page
			              return (
			                <li
			                  tabIndex="-1"
			                  className={['result', `result-${result.type}`, this.props.selected && result.id === this.props.selected.id ? 'active' : ''].join(' ')}
			                  key={result.id}
			                  ref={this.props.selected && result.id === this.props.selected.id ? this.props.focusable : null}
			                  onMouseEnter={() => { this.props.selectResult(result) }}
			                >
			                  <a className="result-link" href={result.url}>
			                    <ResultComponent result={result}/>
			                  </a>
			                </li>
			              )
			            })}
			          </ul>
			        </div>
			      </div>
			    )
			  })}
			</ul>
		)
	}
}